<div class="content-with-filled-button">
        <h1 class="title">{{ copyService.copies.credit_selection_tittle }}</h1>
        <p class="sub-title">{{ copyService.copies.credit_selection_sub_tittle }}</p>
        <form [formGroup]="formGroup">
        <div class="checkbox" *ngFor="let checkbox of checkboxListPrivate">
                <voxel-checkbox class="operation-check-box"  id="operationCurrencyId" 
                (checkboxChange)="checkboxChange($event)" formControlName="check"
                [checked]="checkbox.checked" ngDefaultControl>                 
                </voxel-checkbox>
                        <p class="label">
                                {{checkbox.label}} {{checkbox.value}}
                        </p>
                        <p class="monto">
                                {{checkbox.monto}}
                        </p>
                        <p class="div"></p>
                </div>
        </form>
       
</div>
<app-controls id="docIntroBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.metodo_desembolso_next_button" (next)="next()" [nextDisabled]="!formGroup.valid"></app-controls>